export default "__VITE_ASSET__21dffbc6__"